/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface FindByCustomerFeedMillId$Params {
  customerId: number;
}

export function findByCustomerFeedMillId(http: HttpClient, rootUrl: string, params: FindByCustomerFeedMillId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
  const rb = new RequestBuilder(rootUrl, findByCustomerFeedMillId.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerFeedMill>>;
    })
  );
}

findByCustomerFeedMillId.PATH = '/api/customer/feedMill/{customerId}';
